import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import RatingAndReviews from 'components/consumer/RatingAndReviews';
import BVRatingSummary from 'components/consumer/PDP/BazaarVoice/BVRatingSummary';
import { useBazaarVoiceEnabled } from 'hooks/useBazaarVoice';
import ModularPDPRatingAndReviews from './ModularPDPRatingAndReviews';
import usePDPBasicDetails from '../state/context/usePDPBasicDetails';

const CUSTOMER_PHOTOS_ID = '#PDPCustomerPhotos';

const PDPRatingsSection = ({
  numberOfReviews,
  pdpIsModularBYOProduct,
  rating,
  reviewsLoading,
}) => {
  const history = useHistory();
  const basicDetails = usePDPBasicDetails();
  const baseSku = basicDetails?.data?.sku || null;
  const isBVEnabled = useBazaarVoiceEnabled();

  const onRatingsAndReviewClick = useCallback(
    event => {
      event.preventDefault();
      history.push('customer-reviews');
    },
    [history]
  );

  if (isBVEnabled) {
    return <BVRatingSummary productId={baseSku} />;
  }

  if (pdpIsModularBYOProduct) {
    return (
      <ModularPDPRatingAndReviews
        onClick={onRatingsAndReviewClick}
        href={CUSTOMER_PHOTOS_ID}
      />
    );
  }

  return (
    <RatingAndReviews
      loading={reviewsLoading}
      rating={rating}
      numberOfReviews={numberOfReviews}
      onClick={onRatingsAndReviewClick}
      href={CUSTOMER_PHOTOS_ID}
    />
  );
};

PDPRatingsSection.propTypes = {
  numberOfReviews: PropTypes.number,
  pdpIsModularBYOProduct: PropTypes.bool,
  rating: PropTypes.number,
  reviewsLoading: PropTypes.bool,
};

export default PDPRatingsSection;
